<template>
  <v-layout row wrap class="rightbox CSChatThai " v-if="detail" style="border: solid; border-width: 1px; border-color: #fff; border-bottom: none; border-top: none; background: #fff; height: calc(100vh - 64px);">
    <!-- modal picture -->
      <div id="myModalR" class="modal">
        <div id="headcaption">
          <v-container>
            <v-layout row wrap>
              <v-flex xs2 md2 sm2 style="text-align: right; padding-right: 2vw;">
                <v-avatar class="user-photo">
                  <img v-if="picSend" :src="picSend" class="alligator-turtle">
                  <img v-else-if="typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                  <img v-else-if="typeuser === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                  <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                </v-avatar>
              </v-flex>
              <v-flex xs9 md9 sm9>
                <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{filenameSend}} </p>
                <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> {{$t('Dialog.showImage.by')}} {{nicknameSend}}
                </p>
                <p style="font-size: 12px;">{{$t('Dialog.showImage.date')}} &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
                </p>
              </v-flex>
              <v-flex xs1 md1 sm1>
                <span class="closeR" @click="closemodal()">&times;</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
                <v-btn depressed small class="btnallow text-transform" @click="loadpic(filenameSend)">
                  <v-icon>file_download</v-icon>&nbsp;
                    {{$t('AnswerQuestion.keep')}}
                </v-btn>
                <v-btn depressed small class="btncancel text-transform" @click="sendimgonebox(tokenmsgSend)">
                  <v-icon>cloud_upload</v-icon> &nbsp;
                    {{$t('AnswerQuestion.sendOnebox')}}
                </v-btn>
              </v-flex>
            </v-layout>
        </v-container>
        </div>
        <img class="modal-content" id="img02">
    </div>
    <!-- show notes -->
    <v-flex v-if="shownotes" xs12 md12 sm12>
      <v-card flat style="background: #fff;">
        <v-container style="background: #fff; padding: 0px; " v-if="!progressNote">
          <v-toolbar style="background-color: white;">
            <v-btn dark icon flat @click="shownotes = !shownotes">
              <v-icon style="color: black !important; font-size: 25px !important;">chevron_left</v-icon>
            </v-btn>
            <span style="font-size: 18px; color: black;" v-if="listnote.length !== 0">{{$t('RightSide.menu.note')}} ({{listnote.length}})</span>
            <span style="font-size: 18px; color: black;" v-else>{{$t('RightSide.noNote')}}</span>
          </v-toolbar>
            <div style="height: calc(100vh - 128px);" class="scrolling-wrapper-right">
          <div v-for="(item,index) in listnote"  style="padding: 5px; padding-bottom: 0px; width: 100%;" class="noteslist"  @click="detailNote(item.note_id)">
            <v-layout align-center justify-start row wrap>
              <v-avatar class="user-photonote">
                <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle">
                <img v-else-if="item.type ==='business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
               <!--  <img v-else-if="item.type ==='government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle"> -->
                <img v-else-if="item.type ==='bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
              </v-avatar>
              <p style="padding-left: 15px; padding-top: 10px; width: 170px;" class="text2">{{item.nickname}}</p>
            </v-layout>
           <p v-if="item.note_data.text.length > 20" style="color: #787878;padding-top: 2px;" class="" v-html="convert(item.note_data.text.substring(0, 20) + '...' ).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
           <p v-else style="color: #787878;padding-top: 2px;" class="" v-html="convert(item.note_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
             <span style="font-size: 9px;color: #787878 !important;">
              {{date(item.create_date)}} {{time(item.create_date)}}
            </span>
            <v-divider style=" background-color: #bdbdbd5e !important; width: 100%;"></v-divider>
          </div>
        </div>
          <v-fab-transition>
            <v-btn style="background: #2562ae;" fab dark small fixed bottom right  @click="dialogCreatenote = true">
              <v-icon>add</v-icon>
            </v-btn>
          </v-fab-transition>
        </v-container>
        <v-container style="background: #1a222c; padding:5px;" v-else>
          <v-progress-linear :indeterminate="progressNote"></v-progress-linear>
        </v-container>
      </v-card>
    </v-flex>
    <!-- show albums -->
    <v-flex v-if="showalbum" xs12 md12 sm12>
      <v-card flat style="">
        <v-container style="padding: 0px; " v-if="!progressNote">
          <v-toolbar style="background-color: white;">
            <v-btn dark icon flat @click="showalbum = !showalbum">
              <v-icon style="color: black !important; font-size: 20px !important;">chevron_left</v-icon>
            </v-btn>
            <span style="font-size: 18px; color: black;" v-if="listalbum.length !== 0">{{$t('RightSide.menu.album')}} ({{filter_infoalbum.length}})</span>
            <span style="font-size: 18px; color: black;" v-else>{{$t('Dialog.album.noDataAlbum')}}</span>
          </v-toolbar>
          <div style="overflow-y: scroll; height: 80vh;">
            <div v-for="(item, index) in listalbum" v-if="item.state['status'] != 'delete'" style="padding: 5px; padding-bottom: 0px;padding-top: 20px;" class="noteslist" @click="detailAlbums(item._id, index)">
              <v-layout row wrap>
                <h3 v-if="item.albums_name !== ''" style="color:black;">{{item.albums_name}}</h3>
                <h3 v-else style="color:black;">{{date(item.create_date)}}</h3>
                <v-spacer></v-spacer>
                <!-- <p v-if="item.information.length != 0" style="color: white; margin-bottom: 0px;">รวม: {{item.information.length}} ภาพ</p> -->
              </v-layout>
              <v-layout v-if="item.information.length !== 0">
                <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                  <v-layout row wrap style="overflow-y:scroll!important; max-height: 35vh;">
                    <v-flex v-for="(image, index) in item.information" xs4 sm4 md4 v-if="image.status == 'active'">
                      <v-card flat tile>
                        <v-card-media :src="image.link" height="15vh" >
                        </v-card-media>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>
              <v-layout row wrap v-else justify-center align-center >
                <h4 style="color: white;">{{$t('Dialog.album.noDataAlbum')}}</h4>
              </v-layout>
              <v-divider style=" background-color: #bdbdbd5e !important; width: 100%;"></v-divider>
            </div>
          </div>
          <v-fab-transition>
            <v-btn style="background: #2562ae;" fab dark small fixed bottom right @click="dialogCreatealbums = true">
              <v-icon>add</v-icon>
            </v-btn>
          </v-fab-transition>
        </v-container>
        <v-container style="background: #1a222c; padding:5px;" v-else>
          <v-progress-linear :indeterminate="progressNote"></v-progress-linear>
        </v-container>
      </v-card>
    </v-flex>

    <!-- FRIEND INFO -->
    <v-flex v-if="detail.type === 'user' && !shownotes && !showalbum" xs12 md12 sm12 style="height: calc(100vh - 64px); overflow-y: auto;">
      <v-card flat>
        <v-container>
          <v-layout align-center row wrap>
            <v-flex xs6 sm6 md6>
              <v-layout align-center justify-start>
                <v-btn icon @click="toPage()">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-layout align-center justify-end>
                <v-menu v-if="statemember == 'active'">
                  <v-btn slot="activator" icon>
                    <v-icon style=" font-size: 20px !important; color: black !important;">more_vert</v-icon>
                  </v-btn>
                  <v-list style="width: 100%;padding:1vh;" class="CSChatThai">
                    <v-list-tile  @click="toPageTask('/mobile/room/project/')">
                      <v-icon color="gray">fas fa-tasks</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.project')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="showalbum = !showalbum">
                      <v-icon color="gray">fas fa-images</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.album')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="shownotes = !shownotes" >
                      <v-icon color="gray">fas fa-sticky-note</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.note')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="wallpaper()">
                      <v-icon color="gray">fas fa-images</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.setwall')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="daletechat($route.params.roomid, detail.data_room[0].name)">
                      <v-icon color="gray">delete</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.clearChat')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="block(detail.data_room[0].tokenuser,detail.data_room[0].name)" >
                      <v-icon color="red">remove_circle_outline</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.block')}}</v-list-tile-title>
                    </v-list-tile>
                    <!-- <v-list-tile  @click="unfriend(members.tokenuser,members.name)" >
                      <v-icon color="red">remove_circle_outline</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ลบเพื่อน</v-list-tile-title>
                    </v-list-tile> -->
                  </v-list>
                </v-menu>
                <v-menu v-else>
                  <v-btn slot="activator" icon dark>
                    <v-icon style="font-size: 20px !important; color: black !important;">more_vert</v-icon>
                  </v-btn>
                  <v-list style="width: 100%;padding:1vh;" class="CSChatThai">
                    <v-list-tile  @click="daletechat($route.params.roomid, detail.data_room[0].name)">
                      <v-icon color="gray">delete</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.clearChat')}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                  <v-list v-if="statemember === 'block'" style="width: 100%;padding:1vh;" class="CSChatThai">
                    <v-list-tile  @click="unblockfriend(detail.data_room[0])">
                      <v-icon color="gray">mdi-lock-open</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.unblock')}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-center style="background: #fff; ">
            <v-flex xs12 md12 sm12 style="justify-content: center; display: flex;">
              <v-avatar size="90px" class="user-photo" @click="detailimageFriend(detail.data_room[0])">
                <img v-if="detail.data_room[0].profilepicture" :src="detail.data_room[0].profilepicture" class="alligator-turtle">
                <img v-else-if="detail.data_room[0].type === 'business'" src="/static/img/default_profile/business-white.png" class="alligator-turtle">
            <!--     <img v-else-if="detail.data_room[0].type === 'government'" src="/static/img/default_profile/business-white.png" class="alligator-turtle"> -->
                <img v-else-if="detail.data_room[0].type === 'bot'" src="/static/img/default_profile/bot-white.png" class="alligator-turtle">
                <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle">
              </v-avatar>
            </v-flex>
            <v-flex xs12 md12 sm12 style="text-align: center; margin-top: 10px;">
              <v-layout align-center justify-center column>
                <p class="text2" style="color:black; font-size:20px; width: 170px;">{{detail.data_room[0].name}}</p>
                <p class="text2" style="color:#bcbcbc; font-size:16px; width: 170px;">{{detail.data_room[0].status}}</p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container style="padding-top: 2px !important; padding-left: 0px; padding-right: 0px;">
            <v-tabs slot="extension" v-model="activeinfo" fixed-tabs color="transparent" icons-and-text centered>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1" :key="1" @click="toTab(1)" :disabled="statemember !== 'active'">
                <span style="text-transform: none;">{{$t('RightSide.header.profile')}}</span>
                <v-icon style="font-size: 25px !important;color: #2562af !important;">account_box</v-icon>
              </v-tab>
              <!-- <v-tab href="#tab-2" :key="2" @click="toTab(2)" :disabled="statemember !== 'active'">
                <span style="text-transform: none;">{{$t('RightSide.header.image')}}</span>
                <v-icon style="font-size: 25px !important;color: #2562af !important;">collections</v-icon>
              </v-tab>
              <v-tab href="#tab-3" :key="3" @click="toTab(3)" :disabled="statemember !== 'active'">
                <span style="text-transform: none;">{{$t('RightSide.header.file')}}</span>
                <v-icon style="font-size: 25px !important;color: #2562af !important;">file_copy</v-icon>
              </v-tab> -->
              <v-tab v-if="isAccept === true" :key="4" href='#tab-4' @click="toTab(4)" :disabled="statemember !== 'active'">
                <span style="text-transform: none;">{{$t('RightSide.header.privatepolicy')}}</span>
                <img style="width: 25px !important;" src="/static/img/icons/privacy-policy-blue.png"/>
              </v-tab>
            </v-tabs>

            <v-tabs-items class="layoutsearchweb CSChatThai" v-model="activeinfo">
              <v-tab-item key="1" id="tab-1" class="layoutsearchweb">
                <v-list dense class="layoutsearchweb" style="background: none !important;margin-top: 4px !important;">
                  <!-- <v-subheader style="color:black; font-weight: 900;">ข้อมูลส่วนตัว</v-subheader> -->
                  <v-list-tile >
                    <v-list-tile-avatar>
                      <v-icon style="color: #2562af; font-size: 25px !important;" large>email</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="detail.data_room[0].email === ''" style="color: black !important;">-</v-list-tile-title>
                      <v-list-tile-title v-else style="color: black !important;">
                        <span class="EndpointUrl">
                          {{detail.data_room[0].email}}
                          <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="detail.data_room[0].email">file_copy</v-icon>
                        </span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <!-- <v-divider></v-divider > -->
                </v-list>
              </v-tab-item>
              <!-- tab info friend -->
              <v-tab-item key="2" id="tab-2" class="layoutsearchweb" style="overflow-y: hidden;">
                <!-- <v-subheader style="color:white;font-weight: 900;">รูปภาพ</v-subheader> -->
                <v-flex xs12 sm12 md12>
                    <div style="background: #fff; box-shadow: none !important;" v-if="listimageinroom.length != 0">
                    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                      <v-layout row wrap style="overflow-y:scroll!important;max-height: 35vh;">
                        <v-flex v-for="(memb, i) in listimageinroom" xs4 sm4 md4>
                          <v-card flat tile>
                            <v-card-media :src="memb.path" height="15vh" @click="zoom(memb)">
                            </v-card-media>
                            <!-- <v-card-media :src="memb.path" height="15vh" @click="index = memb">
                            </v-card-media> -->

                          </v-card>
                        </v-flex>
                        <v-flex xs4 sm4 md4 style="cursor: pointer;" v-if="showmoreimage">
                          <v-card flat tile>
                            <v-card-media height="15vh" @click="getmoreimage">
                             ..{{$t('ChatSide.Read.readmore')}}..
                            </v-card-media>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>

                    <!-- test pic slide -->
                    <!-- <div id="app">
                      <vuegalleryslideshow :images="images" :index="index" @close="index = null">
                      </vuegalleryslideshow>
                    </div> -->

                  </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> {{$t('RightSide.noImage')}}</h4>
                </v-flex>
              </v-tab-item>
              <!-- tab file friend -->
              <v-tab-item key="3" id="tab-3" class="layoutsearchweb" >
                <!-- <v-subheader style="color:white;font-weight: 900;">ไฟล์</v-subheader> -->
                <v-flex xs12 sm12 md12>
                    <div style="background: #fff;overflow-y:scroll!important;max-height: 40vh;" v-if="listfileinroom.length != 0">
                    <v-list two-line dense dark class="layoutsearchweb" v-for="(memb, index) in listfileinroom" >
                      <v-list-tile>
                        <v-list-tile-avatar :href="memb.path" target="_blank">
                          <v-icon style="color: #2562af;" large> {{extension(memb.path)}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank"><span>{{memb.file_name}}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="CSChatThai">
                            <v-btn depressed small  class="btnallow" @click="loadfile(memb)">
                                {{$t('AnswerQuestion.keep')}}
                              </v-btn>
                            <v-btn depressed small class="btncancel" @click="sendimgonebox(memb.tokenmessage)">
                                <!-- <img src='../assets/image/logo_onebox.png' width="12"> &nbsp;  -->
                                {{$t('AnswerQuestion.sendOnebox')}}
                              </v-btn>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider >
                    </v-list>
                       <!-- <v-list two-line dense class="layoutsearchweb"  v-if="listfileinroom.length % 20 == 0">
                      <v-list-tile  @click="getmorefile">
                        <v-list-tile-content>
                          <v-list-tile-title style="color: white !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;">
                            <span>Show more</span>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider >
                    </v-list> -->
                    <div style="display: flex;justify-content: center; width: 100%;"  v-if="showmorefile">
                    <v-btn depressed dark style="display: flex;justify-content: center; text-transform: none; color: black !important; text-align: center;" class="btncancel"  @click="getmorefile">
                      ..{{$t('ChatSide.Read.readmore')}}..
                    </v-btn>
                  </div>
                </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> {{$t('RightSide.noFile')}}</h4>
                </v-flex>
              </v-tab-item>
              <!-- consent -->
              <v-tab-item key="4" id="tab-4" class="layoutsearchweb">
                <v-subheader style="color:white;font-weight: 900;">{{$t('RightSide.header.privatepolicy')}}</v-subheader>
                <v-flex sm12 md12 lg12 xl12 style="justify-content: center; align-items: center; width: 100%; display: flex;">
                  <v-btn style="font-size: 14px;" depressed class="btnallow"  @click="getAccesstoken()">{{$t('RightSide.header.privatepolicy')}}</v-btn>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
        </v-container>
      </v-card>
    </v-flex>

    <!-- GROUP INFO -->
    <v-flex v-if="detail.type === 'group' && !shownotes && !showalbum" xs12 md12 sm12 style="height: calc(100vh - 64px); overflow-y: auto;">
      <v-card flat style="background: #fff;">
        <v-container style="background: #fff; padding-top: 0px;">
          <v-layout align-center row wrap>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start>
                <v-btn icon @click="toPage()">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end>
                <v-menu v-if="detail.statemember == 'active'">
                  <v-btn slot="activator" icon>
                    <v-icon style=" font-size: 20px !important; color: black !important;">more_vert</v-icon>
                  </v-btn>
                  <v-list style="width: 100%;padding-top:1vh;">
                    <v-list-tile @click="ShowDialog('dialogQrcode')">
                      <img src="/static/img/icons/qr-code.svg" style="width: 22px;">&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.qrCode')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="toPageTask('/mobile/room/project/')">
                      <v-icon color="gray">fas fa-tasks</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.project')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="shownotes = !shownotes" >
                      <v-icon color="gray">fas fa-sticky-note</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.note')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="showalbum = !showalbum">
                      <v-icon color="gray">fas fa-images</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.album')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-for="(item, index) in listMenu" :key="index" v-on:click="ShowDialog(item.dialog)" >
                      <v-icon :color="item.color">{{item.icon}}</v-icon>&nbsp;&nbsp;
                      <v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="daletechat($route.params.roomid, detail.group_name)">
                      <v-icon color="gray">delete</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.clearChat')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="wallpaper()">
                      <v-icon color="gray">fas fa-images</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.setwall')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="leavegroup()">
                      <v-icon color="gray">call_missed_outgoing</v-icon>&nbsp;&nbsp;
                      <v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.leave')}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-menu v-else>
                  <v-btn slot="activator" icon dark>
                    <v-icon style="font-size: 20px !important; color: black !important;">more_vert</v-icon>
                  </v-btn>
                  <v-list style="width: 100%;padding:1vh;" class="CSChatThai">
                    <v-list-tile  @click="daletechat($route.params.roomid, detail.group_name)">
                      <v-icon color="gray">delete</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('RightSide.menu.clearChat')}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap align-center justify-center style="background: #fff; ">
            <v-flex xs12 md12 sm12 style="justify-content: center; display: flex;">
              <!-- <v-badge color="orange darken-1" overlap bottom  style=" height: 10vw !important;" v-if="detail.statemember == 'active'">
                <v-icon slot="badge" dark small style=" font-size: 8px !important;cursor: pointer;" @click="uppic">
                  add_a_photo
                </v-icon>
                <v-avatar class="user-photo" size="90px">
                  <img v-if="detail.picture" :src="detail.picture" class="alligator-turtle" @click="uppic"  style="cursor: pointer;">
                  <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="cursor: pointer; border-color: #e2e2e2; border-style: solid; border-width: thin;" @click="uppic">
                  <div style="display: none;">
                    <input class="CSChatThai" type="file" name="file1" @change="previewImagegroup" accept="image/*" id="uploadpicturegroup"/>
                  </div>
                </v-avatar>
              </v-badge> -->
              <v-avatar class="user-photo" size="90px" v-if="detail.statemember == 'active'" @click="detailGroup(detail)">
                <img v-if="detail.picture" :src="detail.picture" class="alligator-turtle" style="cursor: pointer;">
                <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="cursor: pointer; border-color: #e2e2e2; border-style: solid; border-width: thin;" @click="uppic">
              </v-avatar>
              <v-avatar v-else style="" size="90px" @click="detailGroup(detail)">
                <img v-if="detail.picture" :src="detail.picture" class="alligator-turtle"   style="border: 0px #1a222c !important; border-style:  solid !important; cursor: pointer;">
                <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border: 1px #1a222c !important; border-style: solid !important; cursor: pointer;" >
                </v-avatar>
            </v-flex>
          </v-layout>
          <!-- <v-layout align-center justify-center row wrap> -->
            <v-flex xs12 md12 sm12 style="margin-top: 50px; margin-bottom: 1px;">
              <v-layout align-center justify-center>
                <br>
                <p class="text2" style="font-size: 20px;"> {{$t('RightSide.group')}}&nbsp;: {{detail.group_name}}</p>
              </v-layout>
            </v-flex>
          <!-- </v-layout> -->
        </v-container>
        <v-container style="padding-top: 2px; padding-left: 0px; padding-right: 0px;">
          <v-tabs slot="extension" v-model="activeinfo" fixed-tabs color="transparent" icons-and-text centered>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1" :key="1" @click="toTab(1)" :disabled="statemember !== 'active'">
                <span class="text-transform">{{$t('RightSide.group')}}</span>
                <v-icon style="font-size: 25px !important;color: #2562af !important;">supervised_user_circle</v-icon>
              </v-tab>
              <v-tab href="#tab-2" :key="2" @click="toTab(2)" v-if="detail.count_pending != '0'" :disabled="statemember !== 'active'">
                <span class="text-transform">{{$t('RightSide.pending')}}</span>
                <v-icon style="font-size: 25px !important;color: #2562af !important;">schedule</v-icon>
              </v-tab>
              <!-- <v-tab href="#tab-3" :key="3" @click="toTab(3)" :disabled="statemember !== 'active'">
                รูปภาพ
                <v-icon style="font-size: 25px !important;color: #2562af !important;">collections</v-icon>
              </v-tab>
              <v-tab href="#tab-4" :key="4" @click="toTab(4)" :disabled="statemember !== 'active'">
                ไฟล์
                <v-icon style="font-size: 25px !important;color: #2562af !important;">file_copy</v-icon>
              </v-tab> -->
            </v-tabs>

            <v-tabs-items class="layoutsearchweb" v-model="activeinfo">
              <v-tab-item key="1" id="tab-1" class="layoutsearchweb" style="margin-top: 1vh !important;">
                <v-subheader style="color:black; font-weight: 900;" v-if="detail.count_member != '0'">{{$t('RightSide.member')}} ({{detail.count_member}})</v-subheader>
                <v-subheader style="color:black; justify-content: center;" v-else>{{$t('RightSide.noMember')}}</v-subheader>
                <div style="overflow-y:scroll!important;height: 35vh !important;">
                <v-list dense class="layoutsearchweb" style="background: none !important; cursor: pointer;" v-for="(membactive, index) in memberactive" v-if="detail.count_member !== '0'" :key="membactive.tokenuser">
                  <v-list-tile style="padding: 1vh !important;" >
                    <v-list-tile-avatar @click="detailFriendDialog(membactive)">
                      <img v-if="membactive.profilepicture" :src="membactive.profilepicture" class="alligator-turtle">
                      <img v-else-if="membactive.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                <!--       <img v-else-if="membactive.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle"> -->
                      <img v-else-if="membactive.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                      <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                    </v-list-tile-avatar>
                    <v-list-tile-content @click="detailFriendDialog(membactive)">
                      <v-list-tile-title style="color: black; white-space: nowrap !important; width: 10em;word-break: break-all !important;">
                        {{membactive.nickname}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="token !== membactive.tokenuser && detail.statemember === 'active'">
                      <!-- <v-btn icon ripper @click="leavegroupFriend(membactive.tokenuser,membactive.name,index)">
                        <v-icon color="red" style="font-size: 15px !important;">remove_circle</v-icon>
                      </v-btn> -->
                      <v-btn depressed small dark  class="btnkickgroup text-transform" @click="leavegroupFriend(membactive.tokenuser,membactive.nickname,index)">{{$t('AnswerQuestion.kickMemberGroup')}}</v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider></v-divider >
                </v-list>
                <v-layout v-if="memberactive.length < parseInt(detail.count_member)" row wrap justify-center align-center>
                  <v-btn @click="getmember()" depressed small dark class="CSChatThai btnallow text-transform">
                   {{$t('RightSide.loadmore')}}
                  </v-btn>
                </v-layout>
              </div>
                <v-container style="padding-left: 15vw !important;" v-if="edit === true">
                  <v-btn @click="clickedit()" class="CSChatThai text-transform">
                    {{$t('AnswerQuestion.ok')}}
                  </v-btn>
                </v-container>
              </v-tab-item>

              <!-- -------pending Group----------- -->

              <v-tab-item key="2" id="tab-2" class="layoutsearchweb" style="margin-top: 1vh !important;" v-if="detail.count_pending != '0'">
                <v-subheader style="color:black; font-weight: 900; text-transform: none;" v-if="detail.count_pending != '0'">{{$t('RightSide.pending')}} ({{detail.count_pending}})</v-subheader>
                <div style="overflow-y:scroll!important;height: 35vh !important;">
                <v-list dense class="layoutsearchweb" style="background: none !important; cursor: pointer;" v-for="(membpending, index) in memberpending" v-if="detail.count_pending != '0'" :key="membpending.tokenuser">
                  <v-list-tile style="padding: 1vh !important;" >
                    <v-list-tile-avatar @click="detailFriendDialog(membpending)">
                      <img v-if="membpending.profilepicture" :src="membpending.profilepicture" class="alligator-turtle">
                      <img v-else-if="membpending.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                      <!-- <img v-else-if="membpending.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle"> -->
                      <img v-else-if="membpending.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                        <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                    </v-list-tile-avatar>
                    <v-list-tile-content @click="detailFriendDialog(membpending)">
                      <v-list-tile-title style="color: black; white-space: nowrap !important; width: 10em;word-break: break-all !important;">
                        {{membpending.nickname}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                      <v-btn v-if="detail.statemember == 'active'" depressed small dark  class="btnallow text-transform"  @click="cancelsendinvite(membpending.tokenuser,membpending.nickname)">{{$t('AnswerQuestion.cancelInvite')}}</v-btn>
                  </v-list-tile>
                  <v-divider></v-divider>
                </v-list>
                <v-layout v-if="memberpending.length < parseInt(detail.count_pending)" row wrap justify-center align-center>
                  <v-btn @click="getpending()" depressed small dark class="CSChatThai btnallow text-transform">
                   {{$t('RightSide.loadmore')}}
                  </v-btn>
                </v-layout>
              </div>
              </v-tab-item>

              <!-- -------image Group----------- -->
              <v-tab-item key="3" id="tab-3" class="layoutsearchweb" style="margin-top: 1vh !important;">
                <!-- <v-subheader style="color:white;font-weight: 900;">รูปภาพ</v-subheader> -->
                <v-flex xs12 sm12 md12>
                  <v-card style="background: #fff; box-shadow: none !important;" v-if="listimageinroom.length != 0">
                    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
                      <v-layout row wrap style="overflow-y:scroll!important;max-height: 40vh;">
                        <v-flex v-for="(image, index) in listimageinroom" xs4 sm4 md4 style="cursor: pointer;">
                          <v-card flat tile>
                            <v-card-media
                              :src="image.path"
                              height="15vh"
                              @click="zoom(image)"
                            >
                            </v-card-media>
                          </v-card>
                        </v-flex>
                        <v-flex sm4 md4 xs4 style="cursor: pointer;" v-if="showmoreimage">
                          <v-card flat tile>
                            <v-card-media
                              height="15vh"
                              @click="getmoreimage"
                            >
                              ..{{$t('ChatSide.Read.readmore')}}..
                            </v-card-media>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px; text-transform: none;"> {{$t('RightSide.noImage')}}</h4>
                </v-flex>
              </v-tab-item>

              <!-- -------file Group----------- -->
              <v-tab-item key="4" id="tab-4" class="layoutsearchweb" style="margin-top: 1vh !important;">
                <!-- <v-subheader style="color:white;font-weight: 900;">ไฟล์</v-subheader> -->
                <v-flex sm12 md12 xs12>
                  <v-card style="background: #fff; overflow-y:scroll!important;max-height: 40vh;" v-if="listfileinroom.length != 0">
                    <v-list dark two-line dense class="layoutsearchweb" v-for="(file, index) in listfileinroom">
                      <v-list-tile>
                        <v-list-tile-avatar :href="file.path" target="_blank">
                          <v-icon style="color: #2562af;" large>{{extension(file.path)}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="file.path" target="_blank">
                            <span>{{file.file_name}}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="CSChatThai">
                            <v-btn depressed small  class="btnallow text-transform" @click="loadfile(file)">
                                {{$t('AnswerQuestion.keep')}}
                              </v-btn>
                            <v-btn depressed small class="btncancel text-transform"  @click="sendimgonebox(file.tokenmessage)">
                                 {{$t('AnswerQuestion.sendOnebox')}}
                              </v-btn>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider >
                    </v-list>
                    <!-- <v-list dark two-line dense class="layoutsearchweb"  v-if="showmorefile">
                      <v-list-tile  @click="getmorefile">
                        <v-list-tile-content>
                          <v-list-tile-title style="color: white !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis; text-align: center">
                            <span>..Show more..</span>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list> -->
                    <div style="display: flex;justify-content: center; width: 100%;"  v-if="showmorefile">
                    <v-btn depressed dark style="display: flex;justify-content: center; text-transform: none; color: black !important; text-align: center;" class="btncancel"  @click="getmorefile">
                      ..{{$t('ChatSide.Read.readmore')}}..
                    </v-btn>
                  </div>

                  </v-card>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px; text-transform: none;"> {{$t('RightSide.noFile')}}</h4>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          <!-- </v-tabs> -->
        </v-container>
      </v-card>
   </v-flex>
  <InviteGroup :dialogInvite="dialogInvite" :memberpending="memberpending" :member="memberactive" :group_id="detail.group_id" @closeInvite="closeInvite" @invitemembergroup="invitemembergroup"></InviteGroup>
  <ManageGroup :dialogManageGroup="dialogManageGroup" :detail="detail" @closeManageGroup="closeManageGroup"></ManageGroup>
  <NoteDialog :dialogNote="dialogNote" :note_id="note_id" @closeNote="closeNote" @editNote="editNote" @removeNote="removeNote"></NoteDialog>
  <CreateNoteDialog :dialogCreatenote="dialogCreatenote" :tokenroom="room" @closeCreatenote="closeCreatenote" @CreateNote="CreateNote"></CreateNoteDialog>
  <QrcodeGroup :dialogQrcode="dialogQrcode" :detail="detail" @closeQrcode="closeQrcode"></QrcodeGroup>
  <AlbumsDialogMobile :dialogAlbums="dialogAlbums" :albums_id="albums_id" @closeAlbums="closeAlbums" @editAlbums="editAlbums" @removeAlbums="removeAlbums"></AlbumsDialogMobile>
  <CreateAlbumsDialogMobile :dialogCreatealbums="dialogCreatealbums" :tokenroom="room" @closeCreatealbums="closeCreatealbums" @CreateAlbums="CreateAlbums"></CreateAlbumsDialogMobile>
  <InforfriendDialogMobile :inforfrienddialog="inforfrienddialog" @closeInforfriend="closeInforfriend" :tokeninforfriend="tokeninforfriend"></InforfriendDialogMobile>
  <SaveOnebox :dialogSaveOnebox="dialogSaveOnebox" @closeSaveOnebox="closeSaveOnebox" :tokenmessage_savebox="tokenmessage_savebox"></SaveOnebox>
  <checkconsentdialog :checkconsentDialog="checkconsentDialog" :url_consent="url_consent" @closeDialogConsent="closeDialogConsent"></checkconsentdialog>

  </v-layout>
  <v-layout row wrap class="rightbox CSChatThai" v-else>
  </v-layout>
</template>

<script>
import QrcodeGroup from '@/components/mobile/dialog/QrcodeDialogMobile'
import InviteGroup from '@/components/mobile/dialog/InviteGroupDialogMobile'
// import LeaveGroup from '@/components/chat/LeaveGroup'
import ManageGroup from '@/components/mobile/dialog/ManageGroupDialogMobile'
import NoteDialog from '@/components/mobile/dialog/NoteDialogMobile'
import CreateNoteDialog from '@/components/mobile/dialog/CreateNoteDialogMobile'
import AlbumsDialogMobile from '@/components/mobile/dialog/AlbumsDialogMobile'
import CreateAlbumsDialogMobile from '@/components/mobile/dialog/CreateAlbumsDialogMobile'
import InforfriendDialogMobile from '@/components/mobile/dialog/InforfriendDialogMobile'
import SaveOnebox from '@/components/mobile/dialog/SaveoneboxDialogMobile'
import checkconsentdialog from '@/components/chat/dialog/consent/check_consent_dialog'

import { Momenttime, Decode, Encode } from '@/services'
import { sync } from 'vuex-pathify'
// import DetailFriend from '@/components/chat/DetailFriend'
// import VueGallerySlideshow from 'vue-gallery-slideshow'
// import vuegalleryslideshow from '@/components/chat/gallery-slideshow'
var _ = require('lodash')
export default {
  data: () => ({
    dataConsent: '',
    isAccept: false,
    checkconsentDialog: false,
    url_consent: '',
    share_token: '',
    Bot_idcovid: process.env.Bot_idcovid,
    images: [],
    index: null,
    dialogSaveOnebox: false,
    tokenmessage_savebox: '',
    dialogQrcode: false,
    profilepicture: '',
    progressNote: false,
    detail: {},
    showmorefile: false,
    showmoreimage: false,
    dialogNote: false,
    dialogManageGroup: false,
    dialogCreatealbums: false,
    note_id: '',
    friend: '',
    token: '',
    // noti: false,
    members: {},
    membersGroup: {},
    member: [],
    memberpending: [],
    dialogInvite: false,
    LeaveGroup: false,
    SetpicGroup: false,
    edit: false,
    room: '',
    activeinfo: 'tab-1',
    // DetailFriend: '',
    relation: '',
    tokenMember: [],
    tokenMemberpending: [],
    listMenu: [],
    listimageinroom: [],
    listfileinroom: [],
    listnote: [],
    selectFile: '',
    dateSend: '',
    timeSend: '',
    nicknameSend: '',
    filenameSend: '',
    tokenmsgSend: '',
    pathSend: '',
    picSend: '',
    name: '',
    typeuser: '',
    shownotes: false,
    dialogCreatenote: false,
    business_id: '',
    windowWidth: '',
    showalbum: false,
    listalbum: [],
    filter_infoalbum: [],
    albums_id: '',
    dialogAlbums: false,
    tokeninforfriend: '',
    inforfrienddialog: false,
    pagemember: 0,
    limit: 10,
    pagepending: 0,
    memberactive: []
  }),
  methods: {
    setListMenu () {
      this.listMenu = [{
        icon: 'group_add',
        title: this.$t('RightSide.menu.invite'),
        dialog: 'Invite',
        color: 'gray'
      },
      {
        icon: 'settings',
        title: this.$t('RightSide.menu.setting'),
        dialog: 'ManageGroup',
        color: 'gray'
      }]
    },
    getmember () {
      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post(process.env.APIgo_api + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagemember,
        limit: this.limit,
        filter: 'active'
      }).then((response) => {
        if (response.data.status === 'success') {
         if (this.pagemember == 0) {
          this.memberactive = response.data.member
         } else {
          this.memberactive.push.apply(this.memberactive,response.data.member)
         }
         this.pagemember = this.pagemember + 1
        } else {
          // this.progressNote = false
        }
      })
    },
    getpending () {
      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post(process.env.APIgo_api + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagepending,
        limit: this.limit,
        filter: 'pending'
      }).then((response) => {
        if (response.data.status === 'success') {
         if (this.pagemember == 0) {
          this.memberpending = response.data.member
         } else {
          this.memberpending.push.apply(this.memberpending,response.data.member)
         }
         this.pagepending = this.pagepending + 1
        } else {
          // this.progressNote = false
        }
      })
    },
    closeDialogConsent (value) {
      this.url_consent = ''
      this.checkconsentDialog = value
    },
    getAccesstoken () {
      this.axios.post(process.env.APInew_getaccesstoken, {
        tokenuser: this.token,
        url: ''
      }).then((response) => {
        if (response.data.status === 'success') {
          this.share_token = response.data.data.url
          this.check_consent(response.data.data.url)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    check_consent (token) {
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then((response) => {
        if (response.data.result === 'success') {
          this.url_consent = ''
          // localStorage.setItem('check_consent', response.data.data.status)
          if (response.data.data.status === 'approved') {
            this.checkconsentDialog = true
            this.url_consent = response.data.data.response.elements.choice.url + token
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    loadfile (item) {
      // console.log(item)
      this.axios.get(item.path, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', item.file_name)
        document.body.appendChild(link)
        link.click()
      })
    },
    wallpaper () {
      this.$router.push('/mobile/wallpaper/' + this.$route.params.roomid)
    },
    detailGroup (detailgroup) {
      // console.log(detailgroup)
      if (detailgroup.picture == '') {
        detailgroup.picture = '/static/img/default_profile/group-white.png'
      }
      this.$swal({
        imageUrl: detailgroup.picture,
        imageHeight: 250,
        showCloseButton: true,
        showConfirmButton: false,
      })
    },
    detailimageFriend (detailfriend) {
      // console.log(detailfriend)
      if (detailfriend.profilepicture == '') {
        detailfriend.profilepicture = '/static/img/default_profile/man-white.png'
      }
      this.$swal({
        imageUrl: detailfriend.profilepicture,
        imageHeight: 250,
        showCloseButton: true,
        showConfirmButton: false,
      })
    },
    daletechat (tokenroom, detailroom) {
      // console.log(detailroom)
      this.$swal({
        // title: detailroom,
        // text: 'คุณต้องการลบแชท ' + detailroom +' ใช่หรือไม่?',
        text: this.$t('Alert.Right.clearChat'),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/setisactive', {tokenroom: tokenroom, tokenuser: this.token, is_active: 'false'}).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              this.chIsactive = tokenroom
            }
          })
        }
      })
    },
    loadpic (filenameSend) {
      this.axios.get(this.pathSend, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    sendimgonebox (tokenmessage) {
      // console.log(this.dialogSaveOnebox)
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = false
    },
    toPage () {
      this.$emit('chat', true)
      this.$router.push('/mobile/room/' + this.$route.params.roomid)
    },
    toPageTask (path) {
      // console.log(path)
      this.$router.push(path + this.$route.params.roomid)
    },
    toTab (tab) {
      if (tab === 1) {
        this.tabs = 'tab-1'
        // console.log(this.tabs)
      } else if (tab === 2) {
        this.tabs = 'tab-2'
        // console.log(this.tabs)
      } else if (tab === 3) {
        this.tabs = 'tab-3'
        // console.log(this.tabs)
      }
    },
    invitemembergroup () {
      // this.getdataroom()
    },
    closeNote (value) {
      this.dialogNote = value
    },
    closeAlbums(value) {
      this.dialogAlbums = value
    },
    closeManageGroup (value) {
      this.dialogManageGroup = value
    },
    closeCreatenote (value) {
      this.dialogCreatenote = value
    },
    closeCreatealbums(value) {
      this.dialogCreatealbums = value
    },
    closeInforfriend (value) {
      this.inforfrienddialog = value
    },
    editNote (msg, id) {
      // console.log(msg)
      // console.log(id)
      var _ = require('lodash')
      var indexid = _.findIndex(this.listnote, function (o) { return o.note_id === id })
      this.listnote[indexid]['note_data']['text'] = msg
      // _.update(listnote, 'note_id',  })
    },
    CreateAlbums (status, infoalbums) {
      // console.log(status)
      // console.log(infoalbums)
      // console.log(this.listalbum)
      if (status === 'success') {
        this.listalbum.unshift(infoalbums)
      }
    },
    editAlbums(data) {
      // console.log(data)
      // console.log(this.listalbum)
      if (data.event === 'edit_name') {
        var indexid = _.findIndex(this.listalbum, function(o) {
          return o._id === data.albums_id
        })
        this.listalbum[indexid]['albums_name'] = data.albums_name
      } else if (data.event === 'add_image') {
        var indexidadd = _.findIndex(this.listalbum, function(o) {
          return o._id === data.albums_id
        })
        for (var i = 0; i < data.info_albums.length; i++) {
          this.listalbum[indexidadd]['information'].unshift(data.info_albums[i])
        }
      } else if (data.event === 'delete_image') {
        var index_id_delete = _.findIndex(this.listalbum, function(o) {
          return o._id === data.albums_id
        })
        for (var i = 0; i < data.image_id.length; i++) {
          var index_image = _.findIndex(this.listalbum[index_id_delete]['information'], function(o) {
            return o.id === data.image_id[i]
          })
          this.listalbum[index_id_delete]['information'].splice(index_image, 1)
        }
      }
    },
    removeAlbums(id) {
      _.remove(this.listalbum, function(o) {
        return o._id === id
      })
    },
    removeNote (id) {
      // console.log(id)
      var _ = require('lodash')
      _.remove(this.listnote, function (o) { return o.note_id === id })
    },
    // createNoteshow () {
    //   this.dialogCreatenote = true
    // },
    detailNote (id) {
      // console.log('detailNote' + id)
      this.dialogNote = true
      this.note_id = id
    },
    cancelsendinvite (tokenuser, name) {
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        // text: 'คุณต้องการยกเลิกคำเชิญ ' + name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Right.cancelInvite', {name: name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/cancelsendinvite', {tokenuser: this.token, tokenfriend: tokenuser, group_id: this.detail.group_id}).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.cancelInvite'),
                'success'
              )
              var index = _.findIndex(this.memberpending, function (o) {
                return o.tokenuser === tokenuser
              })
              // console.log(index)
              // console.log(this.memberpending)
              if (index !== -1) {
                this.memberpending[index].statemember = 'leave'
                this.memberpending.splice(index, 1)
              }
              this.activeinfo = 'tab-2'
            }
          })
        }
      })
    },
    closemodal () {
      var modal = document.getElementById('myModalR')
      modal.style.display = 'none'
    },
    zoom (item) {
      // console.log(item)
      this.dateSend = Momenttime.momentdatethai(item.timestamp)
      this.timeSend = Momenttime.momenttimethai(item.timestamp)
      var modal = document.getElementById('myModalR')
      var modalImg = document.getElementById('img02')
      modal.style.display = 'block'
      modalImg.src = item.path
      this.nicknameSend = item.file_owner
      this.filenameSend = item.file_name
      this.picSend = item.pic_pro
      this.pathSend = item.path
      this.tokenmsgSend = item.okenmessage
      this.typeuser = item.typeuser
    },
    sendonebox (tokenmessage) {
      // console.log('tokenmessage')
      // console.log(tokenmessage)
      this.axios.post(process.env.APIpub + '/save_onebox2', {
        tokenmessage: tokenmessage,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          this.$swal(
            '',
            this.$t('Alert.Success.sendFiletoOnebox'),
            'success'
          )
        } else {
        }
      })
    },
    uppic () {
      $('#uploadpicturegroup').click()
    },
    previewImagegroup () {
      // console.log('previewImagegroup')
      this.selectFile = event.target.files[0]
      if (this.selectFile !== '') {
        var uploadFile = new FormData()
        uploadFile.append('file', this.selectFile, this.selectFile.name)
        uploadFile.append('group_id', this.detail.group_id)
        uploadFile.append('tokenuser', this.token)
        // console.log(uploadFile)
        this.axios.post(process.env.APImanage + '/setimagegroup', uploadFile).then((response) => {
          // console.log(response.data)
          alert(response.data)
          if (response.data['status'] === 'success') {
            this.detail.picture = response.data.filename
            this.selectFile = ''
            document.querySelector('#uploadpicturegroup').value = ''
            // this.$swal(
            //   '',
            //   'เปลี่ยนภาพกลุ่มสำเร็จ',
            //   'success'
            // )
          } else {
            // console.log('fail')
            this.selectFile = ''
            document.querySelector('#uploadpicturegroup').value = ''
            this.$swal(
              '',
              this.$t('Alert.Fail.default.somethingWrong'),
              'error'
            )
          }
        })
      }
    },
    ShowDialog (dialog) {
      if (dialog === 'Invite') {
        this.dialogInvite = true
      } else if (dialog === 'Leave') {
        this.LeaveGroup = true
      } else if (dialog === 'ManageGroup') {
        this.dialogManageGroup = true
      } else if (dialog === 'dialogQrcode') {
        this.dialogQrcode = true
      }
    },
    // ShowDialogdetail (tokenuser) {
    //   this.detailFriend = true
    //   localStorage.setItem('friendtokenuser', tokenuser)
    // },
    findWithAttr (array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    closeInvite (value) {
      this.dialogInvite = value
    },
    closeQrcode (value) {
      this.dialogQrcode = value
    },
    CloseLeave (value) {
      this.LeaveGroup = value
    },
    // CloseSetpic (value) {
    //   this.SetpicGroup = value
    // },
    detailFriendDialog (user) {
      // console.log(user)
      this.tokeninforfriend = user.tokenuser
      this.inforfrienddialog = true
    },
    chat (tokenroom) {
      this.$emit('chat', true)
      localStorage.setItem('room', tokenroom)
      this.$router.push('/mobile/room/' + tokenroom)
    },
    AcceptReq (tokenFriend) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: tokenFriend, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'friend'
          // this.$store.dispatch('listFriend', JSON.stringify(tokenFriend))
          // this.$store.dispatch('Request', 'acceptrequest' + tokenFriend + ' ' + Math.random())
        }
      })
    },
    RemoveReq (tokenFriend) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: tokenFriend, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'unknown'
          // this.$store.dispatch('sendRequest', 'removerequestfriend' + tokenFriend)
        }
      })
    },
    AddFriend (tokenFriend) {
      this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenFriend, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          // this.$store.dispatch('sendRequest', tokenFriend)
        } else {
          alert('Error!!!')
        }
      })
    },
    unblock (tokenFriend) {
      this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {tokenuser: this.token}).then((response) => {
        var room = response.data['listBlockFriend'][this.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom']
        this.axios.post(process.env.APImanage + '/unblockfriend', { tokenfriend: tokenFriend, tokenuser: this.token, tokenroom: room }).then((response) => {
          if (response.data['status'] === 'success') {
            this.$swal(
              '',
              'ยกเลิกการบล็อคสำเร็จ.',
              'success'
            )
            this.relation = 'friend'
            this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {tokenuser: this.token}).then((response) => {
              // this.$store.dispatch('listFriend', 'listBlockFriend' + this.tokenFriend)
            })
          }
        })
      })
    },
    unblockfriend (item) {
      // console.log(item)
      this.axios.post(process.env.APImanage + '/unblockfriend', { tokenfriend: item.tokenuser, tokenuser: this.token, tokenroom: this.$route.params.roomid }).then((response) => {
        if (response.data['status'] === 'success') {
          // this.getlistblock()
          this.statemember = 'active'
          this.relation = 'friend'
          item.event = 'unblock_friend'
          item.statemember = 'active'
          item.tokenroom = this.$route.params.roomid
          // this.unblock_friend = item
          this.block_friend = item
          this.$swal('', this.$t('Alert.Success.unblock'), 'success')
          this.$router.push('/mobile/room/' + this.$route.params.roomid)
        }
      })
    },
    leavegroupFriend (tokenuser, name, index) {
      this.$swal({
        title: this.detail.group_name,
        // text: 'คุณต้องการลบ ' + name + ' ออกจากกลุ่ม ' + this.detail.group_name + ' ?',
        text: this.$t('Alert.Right.deleteFriendGroup', {name: name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // process.env.APIgo_api + '/v1/kick-group'
          // process.env.APImanage + '/kickmember'
          this.axios.post(process.env.APIgo_api + '/v1/kick-group', { group_id: this.detail.group_id, tokenuser: this.token, listmember: [tokenuser] }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.removeFriendGroup'),
                'success'
              )
              // if (index >= 0) {
              //   this.memberactive[index].statemember = 'leave'
              //   this.memberactive.splice(index, 1)
              // }
              this.activeinfo = 'tab-1'
            }
          })
        }
      })
    },
    unfriend (tokenuserfriend, name) {
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: this.$t('Alert.RemoveFriend', {name: name}),
        type: 'warning',
        // imageUrl: '../assets/image/remove2.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
            this.friend = response.data['listfriend']
            // var index = this.findWithAttr(this.friend, 'tokenuser', tokenuserfriend)
            this.axios.post(process.env.APImanage + '/removefriend', { tokenfriend: tokenuserfriend, tokenuser: this.token, tokenroom: localStorage.getItem('room') }).then((response) => {
              if (response.data['status'] === 'success') {
                // console.log(response)
                this.$swal(
                  '',
                  this.$t('Alert.Success.removefriend'),
                  'success'
                )
                this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
                  this.friend = response.data['listfriend']
                  // this.$store.dispatch('listFriend', 'removefriend' + tokenuserfriend)
                })
                this.$router.push('/mobile/homepage')
              }
            })
          })
        }
      })
    },
    block (tokenuserfriend, name) {
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        // text: 'คุณต้องการบล็อก ' + name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Blocking', {name: name}),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/blockfriend', { tokenfriend: tokenuserfriend, tokenuser: this.token, tokenroom: this.$route.params.roomid }).then((response) => {
            if (response.data['status'] === 'success') {
              // console.log(response.data)
              this.$swal(
                '',
                this.$t('Alert.Success.block'),
                'success'
              )
              this.block_friend = {
                tokenuser: tokenuserfriend,
                timestamp: response.data.timestamp,
                event: 'block_friend',
                tokenroom: this.$route.params.roomid
              }
              this.statemember = 'block'
              // console.log(this.block_friend)
              this.$router.push('/mobile/room/' + this.$route.params.roomid)
            }
          })
        }
      })
    },
    clickedit () {
      this.edit = !this.edit
      this.activeinfo = 'tab-1'
    },
    leavegroup () {
      // this.token = this.$cookie.get('tokenuser')
      this.$swal({
        title: this.detail.group_name,
        // text: 'คุณต้องการออกจากกลุ่ม ' + this.detail.group_name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Right.leaveGroup'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // process.env.APImanage + '/leavegroup'
          // process.env.APIgo_api + '/v1/leave-group'
          this.axios.post(process.env.APIgo_api + '/v1/leave-group', {group_id: this.detail.group_id, tokenuser: this.token, listmember: [this.token]}).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.success'),
                'success'
              )
              this.$router.push('/mobile/homepage')
            }
          })
        }
      })
    },
    getmoreimage () {
      // console.log(this.listimageinroom[this.listimageinroom.length-1].timestamp)
      if (this.listimageinroom !== []) {
        var time = this.listimageinroom[this.listimageinroom.length - 1].timestamp
        // if (this.listimageinroom != []){
        //   time = this.listimageinroom[length-1].timestamp
        // }
        this.axios.post(process.env.APIpub + '/file/twe_img', {tokenuser: this.token, tokenroom: this.room, time_in: time, type: this.typeuser, business_id: this.business_id}).then((response) => {
          // console.log(response.data['data'])
          if (response.data['data'].length === 20) {
            this.showmoreimage = true
          } else {
            this.showmoreimage = false
          }
          this.listimageinroom.push.apply(this.listimageinroom, response.data['data'])
        })
      }
    },
    getmorefile () {
      // console.log(this.listfileinroom[this.listfileinroom.length-1].timestamp)
      if (this.listfileinroom !== []) {
        var time = this.listfileinroom[this.listfileinroom.length - 1].timestamp
        // if (this.listimageinroom != []){
        //   time = this.listimageinroom[length-1].timestamp
        // }
        this.axios.post(process.env.APIpub + '/file/twe_file', {tokenuser: this.token, tokenroom: this.room, time_in: time, type: this.typeuser, business_id: this.business_id}).then((response) => {
          // console.log(response.data['data'])
          if (response.data['data'].length === 20) {
            this.showmorefile = true
          } else {
            this.showmorefile = false
          }
          this.listfileinroom.push.apply(this.listfileinroom, response.data['data'])
        })
      }
    },
    getimage () {
      this.images = []
      this.axios.post(process.env.APIpub + '/file/twe_img', {tokenuser: this.token, tokenroom: this.room, time_in: '', type: this.typeuser, business_id: this.business_id}).then((response) => {
        // console.log(response.data['data'])
        if (response.data['data'].length === 20) {
          this.showmoreimage = true
        } else {
          this.showmoreimage = false
        }
        this.listimageinroom = response.data['data']
        // test vue gallery
        for (var i = 0; i < this.listimageinroom.length; i++) {
          this.images[i] = this.listimageinroom[i].path
        }
        // console.log(this.images)
      })
    },
    getfile () {
      this.axios.post(process.env.APIpub + '/file/twe_file', {tokenuser: this.token, tokenroom: this.room, time_in: '', type: this.typeuser, business_id: this.business_id}).then((response) => {
        // console.log(response.data['data'])
        if (response.data['data'].length === 20) {
          this.showmorefile = true
        } else {
          this.showmorefile = false
        }
        this.listfileinroom = response.data['data']
      })
    },
    zoomgroup (src) {
      this.$swal({
        imageUrl: src,
        showCloseButton: true,
        animation: true,
        showCancelButton: false,
        showConfirmButton: false
      })
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1]
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else {
        return 'fas fa-file-alt'
      }
    },
    count_memberpendingactive (member) {
      // console.log(member)
      var _ = require('lodash')
      return _.filter(member, function (member) { return member.statemember === 'pending' })
    },
    count_memberactive (member) {
      var _ = require('lodash')
      return _.filter(member, function (member) { return member.statemember === 'active' })
    },
    convert (msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      return processedContent
    },
    CreateNote (status, createdate, noteid, tokenroom, updatedate, text) {
      if (status === 'success') {
        var _ = require('lodash')
        if (_.find(this.listnote, function (o) { return o.note_id === noteid }) === undefined) {
          this.listnote.unshift({create_date: createdate,
            nickname: localStorage.getItem('name'),
            note_data: {
              image: [],
              text: text
            },
            note_id: noteid,
            owner: this.token,
            profilepicture: localStorage.getItem('profilepicture'),
            tokenroom: tokenroom,
            type: localStorage.getItem('type_user'),
            update_date: updatedate
          })
          this.listnote = _.sortBy(this.listnote, function (dateObj) {
            return new Date(dateObj.create_date)
          }).reverse()
          this.listnote = _.unionBy(this.listnote, 'note_id')
        }
      }
    },
    getnote () {
      this.listnote = []
      this.progressNote = true
      this.axios.post(process.env.APImanage + '/getlistnote2', {tokenuser: this.token, tokenroom: this.room}).then((response) => {
        if (response.data.status === 'success') {
          this.progressNote = false
          this.listnote = response.data.list_note
          var _ = require('lodash')
          this.listnote = _.sortBy(this.listnote, function (dateObj) {
            return new Date(dateObj.create_date)
          }).reverse()
          this.listnote = _.unionBy(this.listnote, 'note_id')
        } else {
          this.progressNote = false
        }
      })
    },
    date (timestamp) {
      // return Momenttime.momentdatethai(timestamp)
      if (this.$i18n.locale == 'th') {
        return Momenttime.momentdatethai(timestamp)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.momentdatecn(timestamp)
      } else {
        return Momenttime.momentdateen(timestamp)
      }
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    getdataroom () {
      this.shownotes = false
      this.detail = {}
      this.axios.post(process.env.APImanage + '/getroom', {tokenuser: this.token, tokenroom: this.$route.params.roomid}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.detail = response.data
          this.statemember = response.data.statemember
          // console.log(this.detail)
          if (this.detail.data_room[0].type === 'bot') {
            this.getConsent(this.detail.data_room[0].tokenuser, this.$route.params.roomid)
          }
          this.getimage()
          this.getfile()
          this.getmember()
          this.getpending()
          // if (response.data.data_room[0].statemember === 'active') {
            this.getnote()
            this.getListAlbums()
          // }
        }
      })
    },
    getConsent (botid, tokenroom) {
      this.axios.post(process.env.APIalpine + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = Encode.encode(response.data.data)
            this.$router.push('/check-consent/' + tokenroom + `/?data_consent=${dataConsent}`)
          } else {
            this.dataConsent = response.data.data
            this.isAccept = response.data.isAccept
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getnoteid (id) {
      var _ = require('lodash')
      if (_.find(this.listnote, function (o) { return o.note_id === id }) === undefined) {
        this.axios.post(process.env.APImanage + '/getnote', {note_id: id}).then((response) => {
          if (response.data.status === 'success') {
            this.listnote.unshift({create_date: response.data.list_note[0].create_date,
              nickname: response.data.list_note[0].nickname,
              note_data: {
                image: [],
                text: response.data.list_note[0].note_data.text
              },
              note_id: response.data.list_note[0].note_id,
              owner: response.data.list_note[0].owner,
              profilepicture: response.data.list_note[0].profilepicture,
              tokenroom: response.data.list_note[0].tokenroom,
              type: response.data.list_note[0].type,
              update_date: response.data.list_note[0].update_date
            })
            this.listnote = _.sortBy(this.listnote, function (dateObj) {
              return new Date(dateObj.create_date)
            }).reverse()
            this.listnote = _.unionBy(this.listnote, 'note_id')
          }
        })
      }
    },
    getListAlbums() {
      this.listalbum = []
      this.progressNote = true
      this.axios.post(process.env.APIpub + '/getlist_albums', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progressNote = false
          this.listalbum = response.data.data
          // this.filter_infoalbum = this.listalbum.information
          this.filter_infoalbum = _.filter(this.listalbum, function (information) { return information['state']['status'] === 'active' })
          // console.log(this.listalbum)
          // for (var i = 0; i < this.listalbum.length; i++) {
          //   this.filter_infoalbum = _.filter(this.listalbum[i]['information'], function (information) { return information.status === 'active' })
          // }
        }
      })
    },
    detailAlbums(id, index) {
      this.dialogAlbums = true
      this.albums_id = id
    }
  },
  computed: {
    ...sync('*')
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    '$i18n.locale' () {
      this.setListMenu()
    },
    block_friend (data) {
      // console.log(data)
      if (data.event === 'block_friend') {
        this.statemember = 'block'
      } else {
        this.statemember = 'active'
      }
      this.showalbum = false
      this.shownotes = false
      // console.log(this.statemember)
    },
    windowWidth () {
      if (this.windowWidth > 960) {
        this.$router.push('/chat/room/' + this.$route.params.roomid)
      }
    },
    socketmessage () {
      // console.log(this.socketmessage)
      // console.log(this.socketmessage.image_add)
      this.getimage()
      this.getfile()
      var albums_id = this.socketmessage.file_name
      if (this.socketmessage.message === 'addimage_albums') {
        // console.log(this.listalbum)
        var indexidadd = _.findIndex(this.listalbum, function(o) {
          return o._id === albums_id
        })
        if (indexidadd >= 0) {
          for (var i = 0; i < this.socketmessage.image_add.length; i++) {
            this.listalbum[indexidadd]['information'].unshift(this.socketmessage.image_add[i])
            // this.listalbum[indexidadd]['information'] = _.unionBy(this.socketmessage.image_add[i], 'id')
          }
        }
      } else if (this.socketmessage.message === 'delete_images_albums') {
        var albums_id_delete = this.socketmessage.albums_id
        var index_id_delete = _.findIndex(this.listalbum, function(o) {
          return o._id === albums_id_delete
        })
        this.axios.post(process.env.APIpub + '/get_albums', {
          albums_id: albums_id_delete,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then((response) => {
          this.listalbum[index_id_delete]['information'] = response.data.data.information
          for (var i = 0; i < this.listalbum[index_id_delete]['information'].length; i++) {
            var index_image = _.findIndex(this.listalbum[index_id_delete]['information'], function(o) {
              return o.status === 'delete'
            })
            this.listalbum[index_id_delete]['information'].splice(index_image, 1)
          }
        }).catch((error) => {
          if (error.response.data.status === 'fail') {
            console.log(error)
          }
        })
      } else if (this.socketmessage.message === 'create_albums') {
        // console.log('create_albums')
        this.axios.post(process.env.APIpub + '/get_albums', {
          albums_id: albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then((response) => {
          this.listalbum.unshift(response.data.data)
          this.listalbum = _.unionBy(this.listalbum, '_id')
          this.filter_infoalbum = _.filter(this.listalbum, function (information) { return information['state']['status'] === 'active' })
        }).catch((error) => {
          if (error.response.data.status === 'fail') {
            console.log(error)
          }
        })
      } else if (this.socketmessage.message === 'delete_albums') {
        this.filter_infoalbum = _.filter(this.listalbum, function (information) { return information['state']['status'] === 'active' })
        // console.log(this.filter_infoalbum.length)
        // console.log(this.filter_infoalbum.length - 1)
      }
    },
    socketnote () {
      var id = this.socketnote.note_id
      this.getnoteid(id)
    },
    socketupdate_file () {
      if (this.statemember == 'active') {
        // console.log(this.socketupdate_file)
        this.listfileinroom.unshift({
          file_name: this.socketupdate_file.file_name,
          file_owner: this.socketupdate_file.nickname,
          path: this.socketupdate_file.message,
          pic_pro: this.socketupdate_file.path_pic,
          timestamp: this.socketupdate_file.timestamp,
          tokenmessage: this.socketupdate_file.tokenmessage,
          tokenuser: this.socketupdate_file.tokenuser,
          typeuser: this.socketupdate_file.type
        })
      }
    },
    socketupdate_img () {
      if (this.statemember == 'active') {
        // console.log(this.socketupdate_img)
        for (var i = 0; i < this.socketupdate_img.length; i++) {
          this.images[i] = this.socketupdate_img.message
          // console.log(this.images[i])
          // console.log(this.socketupdate_img.length)
        }
        this.images.unshift({
          path: this.socketupdate_img.message
        })
        // console.log(this.images)
        this.listimageinroom.unshift({
          file_name: this.socketupdate_img.file_name,
          file_owner: this.socketupdate_img.nickname,
          path: this.socketupdate_img.message,
          pic_pro: this.socketupdate_img.path_pic,
          timestamp: this.socketupdate_img.timestamp,
          tokenmessage: this.socketupdate_img.tokenmessage,
          tokenuser: this.socketupdate_img.tokenuser,
          typeuser: this.socketupdate_img.type
        })
      }
    },
    socket_kickmember (data) {
      // console.log(data)
      var self = this
      data.listkick.forEach(function (item) {
        if (self.token === item) {
          self.memberactive.statemember = 'leave'
        }
        var index = _.findIndex(self.memberactive, function (o) { return o.tokenuser === item })
        if (index >= 0) {
          self.memberactive[index].statemember = 'leave'
          self.memberactive.splice(index, 1)
        }
      })
      this.detail.count_member = parseInt(this.detail.count_member) - 1
    },
    socketinvite_group (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: data.list_invite}).then((response) => {
          // console.log(response.data)
          // console.log(this.detail.data_room)
          for (var i = 0; i < response.data.user.length; i++) {
            var user = response.data.user[i]
            if (response.data.user[i].type === 'user') {
              user.statemember = 'pending'
              user.nickname = response.data.user[i].name
              // this.detail.data_room.push(user)
              this.memberpending.push(user)
              this.memberpending = _.unionBy(this.memberpending, 'tokenuser')
              // console.log(`count_pending old: ${this.detail.count_pending}`)
              this.detail.count_pending = parseInt(this.detail.count_pending) + 1
              // console.log(`count_pending: ${this.detail.count_pending}`)
            } else {
              user.statemember = 'active'
              user.nickname = response.data.user[i].name
              // this.detail.data_room.push(user)
              this.memberactive.push(user)
              this.memberactive = _.unionBy(this.memberactive, 'tokenuser')
              // this.detail.data_room.push(user)
              // this.detail.count_member = parseInt(this.detail.count_member) + 1
              // console.log(`count_active: ${this.detail.count_member}`)
            }
          }
        })
      }
    },
    socketactive_group (data) {
      // console.log(data)
      // if (this.detail.type === 'group' && this.count_memberpendingactive(this.detail.data_room).length !== 0 && this.detail.group_id === data.groupid) {
      //   var index = _.findIndex(this.detail.data_room, function (o) { return o.tokenuser === data.tokenuser })
      //   if (index >= 0) {
      //     this.detail.data_room[index].statemember = 'active'
      //     this.detail.statemember = 'active'
      //   }
      // }
      if (this.detail.group_id === data.groupid) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.tokenuser]}).then((response) => {
          // console.log(response.data.user[0])
          // หาข้อมูล user active
          var user = response.data.user[0]
          user.statemember = 'active'
          user.nickname = response.data.user[0].name
          this.memberactive.push(user)
          this.memberactive = _.unionBy(this.memberactive, 'tokenuser')
          // ลบ list user pending ที่เพิ่ง active
          var index = _.findIndex(this.memberpending, function (o) { return o.tokenuser === data.tokenuser })
          if (index >= 0) {
            this.memberpending.splice(index, 1)
          }
          // console.log(`member old: ${this.detail.count_member}`)
          this.detail.count_member = parseInt(this.detail.count_member) + 1
          if (response.data.user[0].type !== 'bot') {
            this.detail.count_pending = parseInt(this.detail.count_pending) - 1
          }
          // console.log(`member new: ${this.detail.count_member}`)
        })
      }
    },
    socketleave_group (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // var self = this
        // data.listkick.forEach(function (item) {
        //   if (self.token === item) {
        //     self.detail.statemember = 'leave'
        //   }
        //   var index = _.findIndex(self.detail.data_room, function (o) { return o.tokenuser === item })
        //   if (index >= 0) {
        //     self.detail.data_room.splice(index, 1)
        //   }
        // })
        // ลบ list user active
        var index = _.findIndex(this.memberactive, function (o) { return o.tokenuser === data.tokenuser })
        if (index >= 0) {
          this.memberactive.splice(index, 1)
        }
        this.detail.count_member = parseInt(this.detail.count_member) - 1
      }
    },
    socketcencel_group (data) {
      // console.log(data)
      // if (this.detail.type === 'group' && this.count_memberpendingactive(this.detail.data_room).length !== 0 && this.detail.group_id === data.group_id) {
      //   // ลบ group req
      //   var index = _.findIndex(this.detail.data_room, function (o) { return o.tokenuser === data.tokenuser })
      //   if (index >= 0) {
      //     this.detail.data_room.splice(index, 1)
      //   }
      // }
      // ลบ list user pending
      var index = _.findIndex(this.memberpending, function (o) { return o.tokenuser === data.tokenuser })
      if (index >= 0) {
        this.memberpending.splice(index, 1)
      }
      this.detail.count_pending = parseInt(this.detail.count_pending) - 1
    },
    '$route.params.roomid' () {
      // console.log('miew')
      this.room = this.$route.params.roomid
      this.getdataroom()
      this.getListAlbums()
    }
  },
  created () {
    this.business_id = localStorage.getItem('business_id')
    this.typeuser = localStorage.getItem('type_user')
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.room = this.$route.params.roomid
    this.shownotes = false
    this.showalbum = false
    this.getdataroom()
    this.setListMenu()
  },
  components: {
    InviteGroup,
    NoteDialog,
    CreateNoteDialog,
    ManageGroup,
    QrcodeGroup,
    AlbumsDialogMobile,
    CreateAlbumsDialogMobile,
    InforfriendDialogMobile,
    SaveOnebox,
    checkconsentdialog
    // vuegalleryslideshow
  }
}
</script>

<style type="text/css" scoped>
.text-transform {
  text-transform: none;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}
.scrolling-wrapper-right {
  overflow-y: auto;
}
.scrolling-wrapper-right::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}
.scrolling-wrapper-right::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.btnkickgroup {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #ff3939 !important;
  color: white !important;
}
>>>.theme--dark.v-list {
  background-color: white !important;
  color: #fff;
}
>>>.[data-v-c67fc686] .theme--dark.v-list {
  background: #ffffff !important;
}
>>>.v-list .layoutsearchweb .v-list--dense .v-list--two-line .theme--dark {
  background: #ffffff !important;
}
>>>.v-badge--overlap.v-badge--bottom .v-badge__badge {
    left: 60px;
    top: 60px;
}
.imageTest {
  width: 100px;
  height: 100px;
  background-size: cover;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
  border: 1px solid lightgray;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}
.rightbox{
  height: calc(100vh - 64px);
  background-color: white;
}
>>>.tabsright{
  background-color: #27303e !important;
}
/*test upload*/
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.tabs__item--active {
    opacity: 1;
    color: #53ceff!important;
}
.fileInput {
  color: white;
  /*margin-left: 5px;*/
}
.inputWrapper {
  height: 32px;
  width: 70px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  margin-top: 5vh;
  margin-left: 30px;
}
.namemem {
  /*font-family: 'Kanit', sans-serif !important;*/

 font-family: 'CS ChatThaiUI' !important;
  font-weight: 500 !important;
  font-size: 20px;
}
  /*.colorDetail {
    color:rgba(0,0,0,.54);*/
.cardfile {
  background-color: #bff9ff;
  width: 500px;
  height: 300px;
  /*margin-left: 10px;*/
}

.cardlist{
    padding-top: 10px;
    width: 100%;
    height: 30vh;
    overflow-x: hidden;
    overflow-y: scroll;
}

.cardlist::-webkit-scrollbar{
    width: 10px;
}

.cardlist::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}
.selectF{
  background-color: #757575;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
.nonselectF{
  background-color: #ECEFF1;
  width: 100%;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.textdetail {
  white-space: nowrap;
  width: 20em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-align: left;
}
.text {
  white-space: nowrap;
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.text2 {
  white-space: nowrap;
  /* width: 170px; */
  overflow: hidden;
  text-overflow: ellipsis;
}
.fixed-content {
    min-height:100%;
    overflow-y:scroll;
    overflow-x:hidden;
}
.headerlist {
  color:white !important;
  font-weight: 700;
  font-family: 'CS ChatThaiUI' !important;
}
/*.layoutsearchweb {
  background-color: white;
  color: white !important;
}*/


/* The Modal (background) */
.modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    /*padding-top: 20vh;  Location of the box */
    left: 0;
    top: 0;
    width: 100vw; /* Full width */
    height: 100vh; /* Full height */
    overflow: auto; /* Enable scroll if needed */
   /* background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
    padding-top: 10vh;
    margin: auto;
    display: block;
    /*width: 80%;*/
    width: auto;
    height: 50%;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#captionR {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 100vw;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
}

#headcaption {
    margin: auto;
    display: block;

    /*width: 80%;*/
    /*max-width: 100vw;*/
    text-align: left;
    color: white;
    /*padding-left: 15vw ;*/
    padding-top: 1vh;
    padding-bottom: 1vh;
    /*background-color: white;*/
    background-color: #1b232d;
    /*height: 150px;*/
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
    animation-name: zoom;
    animation-duration: 0.6s;
}

@keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
}

/* The Close Button */
.closeR {
    position: absolute;
    top: 15px;
    right: 35px;
    color: white;
    font-size: 25px;
    font-weight: 700px;
    transition: 0.3s;
}

.closeR:hover,
.closeR:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-content {
        /*width: 100vw;*/
    }
}
/*.picgroup:hover {
  background: black !important;
}
*/
.EndpointUrl {
  display: block;
  color: #000;
}
.EndpointUrl:hover .urlcopymessage {
  display: inline !important;
}
.urlcopymessage {
  display: none !important;
}
.noteslist {
  cursor: pointer;
}
.noteslist:hover {
  cursor: pointer;
  background: #a6a6a673;
}
>>>.v-list__tile {
  padding: 0 6px;
}
>>>.theme--dark.v-tabs__bar {
  background-color: #27303e !important;
}
>>>.theme--dark.v-list {
    background: #27303e;
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/layout/RightSideMobile.vue